import React from "react";
import { Row, Col } from "react-bootstrap";
import QualityMeasureStatusCheck from "./QualityMeasureStatusCheck";
import CprStatusCheck from "./CprStatusCheck";
import CprOrderRequest from "./CprOrderRequest";
import CprResponseForm from "../../forms/CprResponseForm";
import CprPatientResponse from "./CprPatientResponse";
import CprData from "./CprData";
import DataEntryNeeded from "../DataEntryNeeded";
import * as CONST from "../../../helpers/Constants";

const Cpr = ({ state, task, children }) => {
  const isCompleted = task.cpr.completed_on_date && task.cpr.attending_provider ? true : false;
  let showCprOrderRequestForm = task.tags.includes("patient-requested-order");
  return (
    <>
      <Row className="flex">
        <Col sm={4} md={3} className="cpr-data">
          <CprData
            data={{
              ...task.cpr,
              task: task,
              taskId: task.id,
              formHandler: (req) => task.formHandler(req),
            }}
          />
          {children}
        </Col>
        <Col sm={8} md={9} className="bb">
          {task.task_type == "quality_measure_status_check" && (
            <>
              <QualityMeasureStatusCheck task={{ ...task }} />
            </>
          )}

          {task.task_type == "cpr_status_check" && (
            <>
              <CprStatusCheck task={{ ...task }} />
            </>
          )}

          {task.task_type == "cpr_response" && (
            <>
              {task.notes ? (
                <Row>
                  {task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED && (
                    <DataEntryNeeded task={{ ...task }} />
                  )}
                  {showCprOrderRequestForm && (
                    <Col
                      md={task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED ? 4 : 6}
                      className={" appointment"}
                    >
                      <CprOrderRequest
                        task={{
                          ...task,
                        }}
                      />
                    </Col>
                  )}

                  {task.response && !showCprOrderRequestForm && (
                    <Col
                      md={task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED ? 4 : 6}
                      className={" appointment"}
                    >
                      <CprResponseForm
                        task={{
                          ...task,
                        }}
                        isCompleted={isCompleted}
                      />
                    </Col>
                  )}
                  <CprPatientResponse task={{ ...task }} />
                </Row>
              ) : (
                <>
                  <CprResponseForm
                    task={{
                      ...task,
                    }}
                    isCompleted={isCompleted}
                  />

                  {task.cpr.sub_status == CONST.CPR.RESULTS_OBTAINED && (
                    <DataEntryNeeded task={{ ...task }} />
                  )}
                </>
              )}
            </>
          )}
        </Col>
      </Row>
    </>
  );
};
export default Cpr;
